import { TimerOutlined } from '@mui/icons-material'
import { useLocation, useNavigate } from 'react-router-dom'
import { usePomodoroStore } from '@stores'
import { formatDigit } from '@utils'
import './floating-pomodoro-status.style.scss'

const TITLES = {
  FOCUS: 'Foco',
  SHORT_BREAK: 'Intervalo curto',
  LONG_BREAK: 'Intervalo longo',
}

const STATUS_LABELS = {
  INITIAL: 'Pronto',
  PAUSE: 'Pausado',
  PROGRESS: 'Ativo',
}

const FloatingPomodoroStatus = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const { activePomodoro, selectedConfig, status, timerState } =
    usePomodoroStore()

  const shouldRender =
    location.pathname !== '/' &&
    selectedConfig &&
    activePomodoro?.title &&
    activePomodoro?.time

  if (!shouldRender) {
    return null
  }

  const hours = timerState?.hours ?? 0
  const minutes = timerState?.minutes ?? 0
  const seconds = timerState?.seconds ?? 0

  return (
    <button
      className="floating-pomodoro-status"
      type="button"
      onClick={() => navigate('/')}
    >
      <div className="floating-pomodoro-status__header">
        <span className="floating-pomodoro-status__eyebrow">
          <TimerOutlined fontSize="inherit" />
          Pomodoro em andamento
        </span>
        <span
          className={`floating-pomodoro-status__state floating-pomodoro-status__state--${status?.toLowerCase?.()}`}
        >
          {STATUS_LABELS[status] ?? 'Ativo'}
        </span>
      </div>

      <strong className="floating-pomodoro-status__phase">
        {TITLES[activePomodoro.title] ?? activePomodoro.title}
      </strong>

      <div className="floating-pomodoro-status__time">
        {!!hours && <span>{formatDigit(hours)}:</span>}
        <span>{formatDigit(minutes)}</span>
        <span>:</span>
        <span>{formatDigit(seconds)}</span>
      </div>
    </button>
  )
}

export { FloatingPomodoroStatus }
